import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    FormGroup,
    Grid,
    IconButton,
    InputAdornment,
    Stack,
    Switch,
    TextField,
    Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useTransaksiStore } from "../../stores/transaksiStore";
// import InfoTagihan from "../InfoTagihan/InfoTagihan";
// import Kalkulator from "../Kalkulator/Kalkulator";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ButtonNumKalkulator from "../ButtonNumKalkulator/ButtonNumKalkulator";
import ButtonKalkulator from "../ButtonKalkulator/ButtonKalkulator";
import "../Kalkulator/Kalkulator.css";
import NumberFormat from "react-number-format";
import toRibuan from "../../utils/toRibuan";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { IOptions } from "../../constants/types";
import useUsersByUkm from "../../services/queries/useUsersByUkm";
import { useAuthStore } from "../../stores/authStore";
import { getLocalUkmId } from "../../utils/handleChangeUkmId";
import useUser from "../../services/queries/useUser";
import useUkm from "../../services/queries/useUkm";
import ListSelectedBarang from "./ListSelectedBarang";
import Swal from "sweetalert2";

interface IModalBayarProps {
    handlingRincianPembayaran: (
        persentaseDiskon: number | null,
        diskon: number | null,
        persentasePajak: number | null,
        pajak: number | null,
        serviceCustom: number | null,
        serviceCustomPersen: number | null,
        tagihan: number,
        uangYangDibayar: number,
        kembalian: number,
        sales: IOptions | null,
    ) => void;
}

type ToggleDiskon = "nominal" | "persentase";

const ModalBayar = (props: IModalBayarProps) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));
    const isLaptopScreen = useMediaQuery(theme.breakpoints.up("md"));
    const isDesktopScreen = useMediaQuery(theme.breakpoints.up("lg"));
    const ukmIdUser = useAuthStore((s) => s.ukmIdUser);
    const initialParamsItem = {
        ukmId: ukmIdUser && ukmIdUser[0],
        size: 100,
        page: 1,
        search: "",
    };
    const { data: usersByUkm, isLoading: isLoadingUsersByUkm } =
        useUsersByUkm(initialParamsItem);
    const [sales, setSales] = useState<IOptions | null>(null);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);
    };

    const mappedUsersByUkm = usersByUkm?.content.map((li) => ({
        id: li.userId,
        nama: li.namaLengkap,
    }));

    const defaultMaskOptions = {
        prefix: "",
        suffix: "",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ".",
        allowDecimal: true,
        decimalSymbol: ",",
        decimalLimit: 2,
        integerLimit: 7,
        allowNegative: false,
        allowLeadingZeroes: false,
    };

    const cart = useTransaksiStore((s) => s.cart);
    const resetCart = useTransaksiStore((s) => s.resetCart);
    const totalHarga = useTransaksiStore((s) => s.totalHarga);
    const isOpenModalBayar = useTransaksiStore((s) => s.isOpenModalBayar);
    const closeModalBayar = useTransaksiStore((s) => s.closeModalBayar);
    const openModalKonfirmasiBayar = useTransaksiStore(
        (s) => s.openModalKonfirmasiBayar,
    );
    const checked = useTransaksiStore((s) => s.checked);
    const setChecked = useTransaksiStore((s) => s.setChecked);
    const isDonePembayaran = useTransaksiStore((s) => s.isDonePembayaran);
    const handlingResetPembayaran = useTransaksiStore(
        (s) => s.handlingResetPembayaran,
    );

    const [inputBayar, setInputBayar] = useState<any>("");
    const [inputDiskon, setInputDiskon] = useState<any | null>("");
    const [toggleDiskon, setToggleDiskon] = useState<ToggleDiskon>("nominal");
    const [displayDiskon, setDisplayDiskon] = useState<number>(0);
    const [totalTagihan, setTotalTagihan] = useState<number>(totalHarga);
    const [kembalian, setKembalian] = useState<number>(0);
    const [isDiskonFocused, setIsDiskonFocused] = useState(false);
    const [displayPajak, setDisplayPajak] = useState<number>(0);
    const [displayService, setDisplayService] = useState<number>(0);

    const focusDiskon = () => setIsDiskonFocused(true);
    const unfocusDiskon = () => setIsDiskonFocused(false);

    const { data: user } = useUser();
    const initialParamsUkm = {
        size: 500,
        page: 1,
        search: "",
    };
    const { data: ukm } = useUkm(initialParamsUkm);

    const ukmId = React.useMemo(() => {
        if (user?.userId) {
            return getLocalUkmId(user?.userId);
        }
        return null;
    }, [user?.userId]);

    const ukmData = React.useMemo(() => {
        if (ukmId) {
            return ukm?.content.find((li) => li.id === ukmId);
        }
        return ukm?.content[0];
    }, [ukm?.content, ukmId]);

    const onQuickActionClick = (digit: number) => {
        let newDisplay = Number(inputBayar) + digit;
        setInputBayar(newDisplay);
        setIsPasClicked(false);
    };

    const onClearButtonClick = () => {
        if (isDiskonFocused) {
            setInputDiskon("");
        } else {
            setInputBayar("");
        }
        setIsPasClicked(false);
    };

    const pilihNominal = () => {
        setToggleDiskon("nominal");
        setInputDiskon("");
    };

    const pilihPersentase = () => {
        setToggleDiskon("persentase");
        setInputDiskon("");
    };

    const onDelButtonClick = () => {
        if (isDiskonFocused) {
            let value = inputDiskon ?? 0;
            if (value === 0) {
                setInputDiskon("");
            } else {
                let newDisplay = Math.floor(value / 10);
                setInputDiskon(newDisplay);
            }
        } else {
            let value = inputBayar ?? 0;
            if (value === 0) {
                setInputBayar("");
            } else {
                let newDisplay = Math.floor(value / 10);
                setInputBayar(newDisplay);
            }
            setIsPasClicked(false);
        }
    };

    const onDigitButtonClick = (digit: number) => {
        if (isDiskonFocused) {
            let newDisplay = String(inputDiskon);
            if (
                (inputDiskon === 0 && digit === 0) ||
                String(inputDiskon).length > 12
            ) {
                return;
            }
            if (inputDiskon !== 0) {
                newDisplay = newDisplay + digit.toString();
            } else {
                newDisplay = digit.toString();
            }
            setInputDiskon(newDisplay);
        } else {
            let newDisplay = String(inputBayar);
            if (
                (inputBayar === 0 && digit === 0) ||
                String(inputBayar).length > 12
            ) {
                return;
            }
            if (inputBayar !== 0) {
                newDisplay = newDisplay + digit.toString();
            } else {
                newDisplay = digit.toString();
            }
            setInputBayar(newDisplay);
        }
        setIsPasClicked(false);
    };

    const onEnterButtonClick = () => {
        // hitungBayar(Number(display));
        // setDisplay("");
    };

    const onZeroButtonClick = () => {
        if (isDiskonFocused) {
            let value = inputDiskon ?? 0;
            let newDisplay = value * 10;
            setInputDiskon(newDisplay);
        } else {
            let value = inputBayar ?? 0;
            let newDisplay = value * 10;
            setInputBayar(newDisplay);
        }
        setIsPasClicked(false);
    };

    const onTripleZeroButtonClick = () => {
        if (isDiskonFocused) {
            let value = inputDiskon ?? 0;
            let newDisplay = value * 1000;
            setInputDiskon(newDisplay);
        } else {
            let value = inputBayar ?? 0;
            let newDisplay = value * 1000;
            setInputBayar(newDisplay);
        }
        setIsPasClicked(false);
    };

    const handleResetRincianPembayaran = useCallback(() => {
        setInputBayar("");
        setInputDiskon("");
        setDisplayDiskon(0);
        setTotalTagihan(0);
        setKembalian(0);
    }, []);

    const [diskonError, setDiskonError] = useState(false);

    const handleRincianPembayaran = useCallback(
        (
            inputPembayaran: number,
            toggleDiskon: "nominal" | "persentase",
            inputDiskon: number | null,
            pajak: number | null,
            serviceCustom: number | null,
            isPasClicked: boolean
        ) => {
            let diskonError = false;
            let hargaSetelahDiskon = totalHarga;

            const diskonValue = inputDiskon ?? 0;

            if (totalHarga > 0) {
                if (toggleDiskon === "nominal") {
                    if (diskonValue >= totalHarga) {
                        diskonError = true;
                        setDisplayDiskon(0);
                        hargaSetelahDiskon = 0;
                    } else {
                        hargaSetelahDiskon = totalHarga - diskonValue;
                        setDisplayDiskon(diskonValue);
                    }
                } else if (toggleDiskon === "persentase") {
                    if (diskonValue > 100) {
                        diskonError = true;
                        setDisplayDiskon(0);
                    } else {
                        const totalDiskon = Math.ceil(totalHarga * (diskonValue / 100));
                        hargaSetelahDiskon = totalHarga - totalDiskon;
                        setDisplayDiskon(totalDiskon);
                    }
                }
            } else {
                setDisplayDiskon(0);
            }

            setDiskonError(diskonError);

            let totalSetelahService = hargaSetelahDiskon;
            let totalSetelahPajak = hargaSetelahDiskon;
            let totalTagihan = hargaSetelahDiskon;

            setDisplayService(0);
            setDisplayPajak(0);

            if (ukmData?.tipeService === "BeforeTax") {
                if (serviceCustom !== null) {
                    const totalService = Math.ceil(hargaSetelahDiskon * (serviceCustom / 100));
                    totalSetelahService = hargaSetelahDiskon + totalService;
                    setDisplayService(totalService);
                }

                if (pajak !== null) {
                    const totalPajak = Math.ceil(totalSetelahService * (pajak / 100));
                    totalSetelahPajak = totalSetelahService + totalPajak;
                    setDisplayPajak(totalPajak);
                } else {
                    totalSetelahPajak = totalSetelahService;
                }

                totalTagihan = totalSetelahPajak;
            } else {
                if (pajak !== null) {
                    const totalPajak = Math.ceil(hargaSetelahDiskon * (pajak / 100));
                    totalSetelahPajak = hargaSetelahDiskon + totalPajak;
                    setDisplayPajak(totalPajak);
                }

                if (serviceCustom !== null) {
                    const totalService = Math.ceil(totalSetelahPajak * (serviceCustom / 100));
                    totalSetelahService = totalSetelahPajak + totalService;
                    setDisplayService(totalService);
                } else {
                    totalSetelahService = totalSetelahPajak;
                }

                totalTagihan = totalSetelahService;
            }

            setTotalTagihan(totalTagihan);
            
            if (isPasClicked || inputPembayaran === totalTagihan + displayDiskon) {
                setInputBayar(totalTagihan);
                setKembalian(0);
            } else {
                setKembalian(inputPembayaran - totalTagihan);
            }

            if (inputPembayaran <= 0) {
                setKembalian(0);
            }
        },
        [totalHarga, ukmData?.tipeService, displayDiskon]
    );
    
    const [isPasClicked, setIsPasClicked] = useState(false);
    
    const handlePasClick = () => {
        setIsPasClicked(true);
        setInputBayar(totalTagihan);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (isPasClicked && event.key === 'Backspace') {
            event.preventDefault();
            onDelButtonClick();
        }
    };
    
    useEffect(() => {
        if (ukmData && ukmData.pajak) {
            const potongan = ukmData.pajak / 100;
            const totalPajak = Math.ceil(totalHarga * potongan);
            const hasilTotalTagihan = totalHarga + totalPajak;
            setDisplayPajak(totalPajak);
            setTotalTagihan(hasilTotalTagihan);
            setKembalian(inputBayar - hasilTotalTagihan);
        }
        
        if (ukmData && ukmData.serviceCustom) {
            const potongan = ukmData.serviceCustom / 100;
            const totalService = Math.ceil(totalHarga * potongan);
            const hasilTotalTagihan = totalHarga + totalService;
            setDisplayService(totalService);
            setTotalTagihan(hasilTotalTagihan);
            setKembalian(inputBayar - hasilTotalTagihan);
        }
    }, [inputBayar, totalHarga, ukmData]);

    useEffect(() => {
        if (ukmData && (inputBayar !== null || inputDiskon !== null)) {
            handleRincianPembayaran(
                inputBayar,
                toggleDiskon,
                inputDiskon.toString().replace(",", "."),
                ukmData?.pajak,
                ukmData?.serviceCustom,
                isPasClicked,
            );
        }
    }, [
        handleRincianPembayaran,
        inputBayar,
        inputDiskon,
        toggleDiskon,
        ukmData,
        isPasClicked,
    ]);

    const currencyMask = createNumberMask({
        ...defaultMaskOptions,
    });

    useEffect(() => {
        if (isDonePembayaran === true) {
            handleResetRincianPembayaran();
            handlingResetPembayaran();
            resetCart();
        }
    }, [
        handleResetRincianPembayaran,
        handlingResetPembayaran,
        isDonePembayaran,
        resetCart,
    ]);

    return (
        <React.Fragment>
            <Dialog
                maxWidth="lg"
                fullWidth
                fullScreen={fullScreen}
                open={isOpenModalBayar}
                onClose={() => {
                    closeModalBayar();
                    setChecked(false);
                    handleResetRincianPembayaran();
                    setIsPasClicked(false);
                }}
                PaperProps={{
                    sx: {
                        borderRadius: { xs: 0, md: 1 },
                        maxHeight: { xs: "100vh", md: "90vh" },
                        minHeight: { xs: "100vh", md: "auto" },
                    },
                }}
            >
                <DialogTitle sx={{ display: { sm: "block", md: "none" }, paddingBottom: 0 }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <IconButton
                            onClick={() => {
                                closeModalBayar();
                                setChecked(false);
                                handleResetRincianPembayaran();
                                setIsPasClicked(false);
                            }}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="h6" fontWeight="bold">
                            Masukkan Pembayaran
                        </Typography>
                    </Stack>
                </DialogTitle>
                <DialogContent sx={{ padding: { xs: 0, md: 1 } }}>
                    <Stack direction={{ xs: "column", md: "row-reverse" }} sx={{ height: "100%" }}>
                        {/* Bagian Kalkulator */}
                        <Grid item xs={12} lg={6}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    height: { xs: "auto", md: "100%" },
                                    padding: { xs: 2, sm: 3, md: 2 },
                                    gap: 2,
                                }}
                            >
                                {/* Input Pembayaran */}
                                <Box>
                                    <NumberFormat
                                        value={inputBayar}
                                        inputMode="numeric"
                                        customInput={TextField}
                                        thousandSeparator="."
                                        decimalSeparator=","
                                        autoFocus={isDesktopScreen}
                                        fullWidth
                                        placeholder="0"
                                        allowNegative={false}
                                        onFocus={unfocusDiskon}
                                        onChange={(
                                            event: React.ChangeEvent<HTMLInputElement>,
                                        ) => {
                                            setInputBayar(
                                                Number(
                                                    event.target.value.replace(
                                                        /\./g,
                                                        "",
                                                    ),
                                                ),
                                            );
                                        }}
                                        onKeyDown={handleKeyDown}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Typography
                                                        variant={isMobile ? "h5" : "h4"}
                                                        fontWeight="bold"
                                                    >
                                                        Rp.
                                                    </Typography>
                                                </InputAdornment>
                                            ),
                                        }}
                                        inputProps={{
                                            inputMode: "numeric",
                                            style: {
                                                fontSize: isMobile ? 24 : 40,
                                                fontWeight: "bold",
                                                textAlign: "right",
                                            },
                                        }}
                                    />
                                </Box>

                                {/* Quick Action Buttons - tetap seperti semula */}
                                <Box
                                    display="grid"
                                    gridTemplateColumns="1fr 1fr 1fr 1fr"
                                    gap={{ xs: 1, lg: 2 }}
                                >
                                    <Button
                                        disabled={isDiskonFocused}
                                        variant="outlined"
                                        onClick={handlePasClick}
                                        data-testid="button-pas"
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: {
                                                    xs: 14,
                                                    md: "subtitle1.fontSize",
                                                },
                                            }}
                                            fontSize={16}
                                        >
                                            {isTabletScreen || fullScreen
                                                ? "Pas"
                                                : "Uang Pas"}
                                        </Typography>
                                    </Button>
                                    <ButtonKalkulator
                                        disabled={isDiskonFocused}
                                        buttonVariant="contained"
                                        onClick={() =>
                                            onQuickActionClick(100000)
                                        }
                                    >
                                        100.000
                                    </ButtonKalkulator>
                                    <ButtonKalkulator
                                        disabled={isDiskonFocused}
                                        buttonVariant="contained"
                                        onClick={() =>
                                            onQuickActionClick(50000)
                                        }
                                    >
                                        50.000
                                    </ButtonKalkulator>
                                    <ButtonKalkulator
                                        disabled={isDiskonFocused}
                                        buttonVariant="contained"
                                        onClick={() =>
                                            onQuickActionClick(20000)
                                        }
                                    >
                                        20.000
                                    </ButtonKalkulator>
                                    <ButtonKalkulator
                                        disabled={isDiskonFocused}
                                        buttonVariant="contained"
                                        onClick={() =>
                                            onQuickActionClick(10000)
                                        }
                                    >
                                        10.000
                                    </ButtonKalkulator>
                                    <ButtonKalkulator
                                        disabled={isDiskonFocused}
                                        buttonVariant="contained"
                                        onClick={() => onQuickActionClick(5000)}
                                    >
                                        5.000
                                    </ButtonKalkulator>
                                    <ButtonKalkulator
                                        disabled={isDiskonFocused}
                                        buttonVariant="contained"
                                        onClick={() => onQuickActionClick(2000)}
                                    >
                                        2.000
                                    </ButtonKalkulator>
                                    <ButtonKalkulator
                                        disabled={isDiskonFocused}
                                        buttonVariant="contained"
                                        onClick={() => onQuickActionClick(1000)}
                                    >
                                        1.000
                                    </ButtonKalkulator>
                                </Box>

                                {/* Number Pad - hanya untuk desktop, tetap seperti semula */}
                                {isLaptopScreen && (
                                    <Box
                                        display="grid"
                                        gridTemplateColumns="1fr 1fr 1fr 1fr"
                                        gap={{ xs: 1, lg: 2 }}
                                    >
                                        <ButtonNumKalkulator
                                            buttonVariant="outlined"
                                            onClick={() =>
                                                onDigitButtonClick(1)
                                            }
                                        >
                                            1
                                        </ButtonNumKalkulator>
                                        <ButtonNumKalkulator
                                            buttonVariant="outlined"
                                            onClick={() =>
                                                onDigitButtonClick(2)
                                            }
                                        >
                                            2
                                        </ButtonNumKalkulator>
                                        <ButtonNumKalkulator
                                            buttonVariant="outlined"
                                            onClick={() =>
                                                onDigitButtonClick(3)
                                            }
                                        >
                                            3
                                        </ButtonNumKalkulator>
                                        <ButtonKalkulator
                                            disabled={false}
                                            buttonVariant="contained"
                                            onClick={onDelButtonClick}
                                        >
                                            Del
                                        </ButtonKalkulator>
                                        <ButtonNumKalkulator
                                            buttonVariant="outlined"
                                            onClick={() =>
                                                onDigitButtonClick(4)
                                            }
                                        >
                                            4
                                        </ButtonNumKalkulator>
                                        <ButtonNumKalkulator
                                            buttonVariant="outlined"
                                            onClick={() =>
                                                onDigitButtonClick(5)
                                            }
                                        >
                                            5
                                        </ButtonNumKalkulator>
                                        <ButtonNumKalkulator
                                            buttonVariant="outlined"
                                            onClick={() =>
                                                onDigitButtonClick(6)
                                            }
                                        >
                                            6
                                        </ButtonNumKalkulator>
                                        <ButtonKalkulator
                                            disabled={false}
                                            buttonVariant="contained"
                                            onClick={onClearButtonClick}
                                        >
                                            C
                                        </ButtonKalkulator>
                                        <ButtonNumKalkulator
                                            buttonVariant="outlined"
                                            onClick={() =>
                                                onDigitButtonClick(7)
                                            }
                                        >
                                            7
                                        </ButtonNumKalkulator>
                                        <ButtonNumKalkulator
                                            buttonVariant="outlined"
                                            onClick={() =>
                                                onDigitButtonClick(8)
                                            }
                                        >
                                            8
                                        </ButtonNumKalkulator>
                                        <ButtonNumKalkulator
                                            buttonVariant="outlined"
                                            onClick={() =>
                                                onDigitButtonClick(9)
                                            }
                                        >
                                            9
                                        </ButtonNumKalkulator>
                                        <Button
                                            variant="contained"
                                            className="is-enter"
                                            onClick={onEnterButtonClick}
                                            sx={{
                                                backgroundColor: "primary",
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: {
                                                        xs: "subtitle1.fontSize",
                                                        md: "h6.fontSize",
                                                    },
                                                }}
                                            >
                                                Enter
                                            </Typography>
                                        </Button>
                                        <ButtonNumKalkulator
                                            buttonVariant="outlined"
                                            onClick={onZeroButtonClick}
                                        >
                                            0
                                        </ButtonNumKalkulator>
                                        <Button
                                            variant="outlined"
                                            className="is-000"
                                            onClick={onTripleZeroButtonClick}
                                        >
                                            <Typography variant="h6">
                                                000
                                            </Typography>
                                        </Button>
                                    </Box>
                                )}
                            </Box>
                        </Grid>

                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{
                                display: { xs: "none", md: "block" },
                            }}
                        />

                        {/* INFO TAGIHAN */}
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={6}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    height: { xs: "auto", md: "100%" },
                                    padding: { xs: 2, sm: 3, md: 2 },
                                    gap: 2,
                                    overflowY: { xs: "visible", md: "auto" },
                                }}
                            >
                                {/* Set Diskon Harga */}
                                <Box>
                                    <Typography variant="h6" fontWeight="bold">
                                        Set Diskon Harga
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="#545E6A"
                                        marginBottom={2}
                                    >
                                        Atur potongan harga berdasarkan nilai
                                        nominal langsung atau nilai persen.
                                    </Typography>
                                    <Grid container alignItems="flex-start">
                                        <Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={6}
                                            lg={isTabletScreen ? 7 : 6}
                                        >
                                            <Stack
                                                display="flex"
                                                direction="row"
                                                spacing={1}
                                                sx={{
                                                    justifyContent: {
                                                        xs: "space-between",
                                                        sm: "flex-start",
                                                    },
                                                    marginRight: {
                                                        xs: 0,
                                                        sm: 2,
                                                    },
                                                }}
                                            >
                                                <Button
                                                    disabled={
                                                        user &&
                                                        !user.akses.transaksi.includes(
                                                            12,
                                                        )
                                                    }
                                                    size="medium"
                                                    fullWidth
                                                    variant={
                                                        toggleDiskon ===
                                                        "nominal"
                                                            ? "contained"
                                                            : "outlined"
                                                    }
                                                    onClick={() =>
                                                        pilihNominal()
                                                    }
                                                    data-testid="button-nominal"
                                                >
                                                    Nominal
                                                </Button>
                                                <Button
                                                    disabled={
                                                        user &&
                                                        !user.akses.transaksi.includes(
                                                            12,
                                                        )
                                                    }
                                                    size="medium"
                                                    fullWidth
                                                    variant={
                                                        toggleDiskon ===
                                                        "persentase"
                                                            ? "contained"
                                                            : "outlined"
                                                    }
                                                    onClick={() =>
                                                        pilihPersentase()
                                                    }
                                                    data-testid="button-persen"
                                                >
                                                    Persentase
                                                </Button>
                                            </Stack>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={6}
                                            lg={isTabletScreen ? 5 : 6}
                                            sx={{ marginTop: { xs: 2, sm: 0 } }}
                                        >
                                            <MaskedInput
                                                disabled={
                                                    user &&
                                                    !user.akses.transaksi.includes(
                                                        12,
                                                    )
                                                }                                                
                                                value={inputDiskon}
                                                mask={currencyMask}
                                                placeholder="0"
                                                id="pay"
                                                onFocus={focusDiskon}
                                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                    setInputDiskon(event.target.value.replace(/\./g, "") ?? "");
                                                }}
                                                render={(ref, props) => (
                                                    <TextField
                                                        inputRef={ref}
                                                        {...props}
                                                        error={
                                                            (toggleDiskon === "persentase" && inputDiskon > 100) ||
                                                            diskonError
                                                        }
                                                        helperText={
                                                            toggleDiskon === "persentase" && inputDiskon > 100
                                                                ? "Diskon harus kurang dari 100 persen"
                                                                : diskonError
                                                                ? "Diskon tidak boleh melebihi total tagihan"
                                                                : " "
                                                        }
                                                        fullWidth
                                                        size="small"
                                                        InputProps={{
                                                            startAdornment:
                                                                toggleDiskon === "nominal" ? (
                                                                    <InputAdornment position="start">
                                                                        <Typography fontWeight="bold">
                                                                            Rp.
                                                                        </Typography>
                                                                    </InputAdornment>
                                                                ) : (
                                                                    ""
                                                                ),
                                                            endAdornment:
                                                                toggleDiskon === "persentase" ? (
                                                                    <InputAdornment position="end">
                                                                        <Typography fontWeight="bold">
                                                                            %
                                                                        </Typography>
                                                                    </InputAdornment>
                                                                ) : (
                                                                    ""
                                                                ),
                                                        }}
                                                        inputProps={{
                                                            inputMode: "numeric",
                                                            style: {
                                                                fontWeight: "bold",
                                                                textAlign: "right",
                                                                height: "18px",
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>

                                {/* Rincian Transaksi */}
                                <Box>
                                    <Typography
                                        variant="h6"
                                        fontWeight="bold"
                                        marginBottom={1}
                                    >
                                        Rincian Transaksi
                                    </Typography>
                                    
                                    <Stack spacing={1}>
                                        {/* Subtotal */}
                                        <Grid container alignItems="center" justifyContent="space-between">
                                            <Grid item xs={6} lg={6}>
                                                <Typography
                                                    color="#76747C"
                                                    variant="body2"
                                                    fontWeight={600}
                                                >
                                                    Subtotal Harga
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} lg={6}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    paddingX={1}
                                                    gap={1}
                                                >
                                                    <Typography fontWeight="bold">
                                                        Rp.
                                                    </Typography>
                                                    <Typography fontWeight="bold">
                                                        {toRibuan(totalHarga)}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>

                                        {/* Diskon */}
                                        <Grid container alignItems="center" justifyContent="space-between">
                                            <Grid item xs={6} lg={6}>
                                                <Typography
                                                    color="#76747C"
                                                    variant="body2"
                                                    fontWeight={600}
                                                >
                                                    Potongan Diskon
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} lg={6}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    bgcolor="#FFF5EC"
                                                    paddingX={1}
                                                    gap={1}
                                                >
                                                    <Typography
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        (Rp.
                                                    </Typography>
                                                    <Typography
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        {toRibuan(
                                                            Number(displayDiskon),
                                                        )})
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>

                                        {/* Service */}
                                        {ukmData && ukmData.serviceCustom && (
                                            <Grid container alignItems="center" justifyContent="space-between">
                                                <Grid item xs={6} lg={6}>
                                                    <Typography
                                                        color="#76747C"
                                                        variant="body2"
                                                        fontWeight={600}
                                                    >
                                                        {`Service (${ukmData.serviceCustom}%)`}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6} lg={6}>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="space-between"
                                                        bgcolor="#FFF5EC"
                                                        paddingX={1}
                                                        gap={1}
                                                    >
                                                        <Typography
                                                            color="#FB923C"
                                                            fontWeight="bold"
                                                        >
                                                            Rp.
                                                        </Typography>
                                                        <Typography
                                                            color="#FB923C"
                                                            fontWeight="bold"
                                                        >
                                                            {toRibuan(
                                                                Number(
                                                                    displayService,
                                                                ),
                                                            )}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        )}

                                        {/* Pajak */}
                                        {ukmData && ukmData.pajak && (
                                            <Grid container alignItems="center" justifyContent="space-between">
                                                <Grid item xs={6} lg={6}>
                                                    <Typography
                                                        color="#76747C"
                                                        variant="body2"
                                                        fontWeight={600}
                                                    >
                                                        {`Pajak (${ukmData.pajak}%)`}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6} lg={6}>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="space-between"
                                                        bgcolor="#FFF5EC"
                                                        paddingX={1}
                                                        gap={1}
                                                    >
                                                        <Typography
                                                            color="#FB923C"
                                                            fontWeight="bold"
                                                        >
                                                            Rp.
                                                        </Typography>
                                                        <Typography
                                                            color="#FB923C"
                                                            fontWeight="bold"
                                                        >
                                                            {toRibuan(
                                                                Number(
                                                                    displayPajak,
                                                                ),
                                                            )}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        )}

                                        {/* Total Tagihan */}
                                        <Grid container alignItems="center" justifyContent="space-between">
                                            <Grid item xs={6} lg={6}>
                                                <Typography
                                                    color="#76747C"
                                                    variant="body2"
                                                    fontWeight={600}
                                                >
                                                    Total Tagihan
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} lg={6}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    bgcolor="#E8F6ED"
                                                    paddingX={1}
                                                    gap={1}
                                                >
                                                    <Typography
                                                        color="#45A779"
                                                        fontWeight="bold"
                                                    >
                                                        Rp.
                                                    </Typography>
                                                    <Typography
                                                        color="#45A779"
                                                        fontWeight="bold"
                                                    >
                                                        {toRibuan(
                                                            Number(totalTagihan),
                                                        )}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>

                                        {/* Uang Dibayar */}
                                        <Grid container alignItems="center" justifyContent="space-between">
                                            <Grid item xs={6} lg={6}>
                                                <Typography
                                                    color="#76747C"
                                                    variant="body2"
                                                    fontWeight={600}
                                                >
                                                    Uang yang Dibayar
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} lg={6}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    bgcolor="#FFF5EC"
                                                    paddingX={1}
                                                    gap={1}
                                                >
                                                    <Typography
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        Rp.
                                                    </Typography>
                                                    <Typography
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        {toRibuan(
                                                            inputBayar === ""
                                                                ? 0
                                                                : inputBayar,
                                                        )}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>

                                        {/* Kembalian */}
                                        <Grid container alignItems="center" justifyContent="space-between">
                                            <Grid item xs={6} lg={6}>
                                                <Typography
                                                    color="#76747C"
                                                    variant="body2"
                                                    fontWeight={600}
                                                >
                                                    Kembalian
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} lg={6}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    bgcolor="#FCEAEA"
                                                    paddingX={1}
                                                    gap={1}
                                                >
                                                    <Typography
                                                        color="#DC2626"
                                                        fontWeight="bold"
                                                    >
                                                        Rp.
                                                    </Typography>
                                                    <Typography
                                                        color="#DC2626"
                                                        fontWeight="bold"
                                                    >
                                                        {toRibuan(kembalian)}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Stack>
                                </Box>

                                {/* Sales */}
                                <Box>
                                    <Typography variant="h6" fontWeight="bold">
                                        Sales
                                    </Typography>
                                    <Typography variant="body2" color="#545E6A">
                                        Atur nama sales transaksi (opsional)
                                    </Typography>
                                    <Autocomplete
                                        disabled={
                                            user &&
                                            !user.akses.transaksi.includes(12)
                                        }
                                        loading={isLoadingUsersByUkm}
                                        disablePortal
                                        options={mappedUsersByUkm ?? []}
                                        getOptionLabel={(option) => option.nama}
                                        isOptionEqualToValue={(option, value) =>
                                            String(option.id) === String(value.id)
                                        }
                                        value={sales}
                                        onChange={(_event, newSales: IOptions | null) => {
                                            setSales(newSales);
                                        }}
                                        size="small"
                                        sx={{ marginTop: 1 }}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder="Nama sales" />
                                        )}
                                    />
                                </Box>

                                {/* FIFO */}
                                <Box
                                    sx={{
                                        visibility: ukmData?.isPro === 0 ? "hidden" : "visible",
                                    }}
                                >
                                    <Typography fontWeight="bold" marginBottom={1}>
                                        Transaksi dengan FIFO
                                    </Typography>
                                    <Stack
                                        direction="row"
                                        spacing={3}
                                        alignItems="center"
                                        flexWrap="wrap"
                                    >
                                        <Typography>Kustom faktur?</Typography>
                                        <FormGroup>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={checked}
                                                        onChange={handleChange}
                                                    />
                                                }
                                                label={checked ? "Ya" : "Tidak"}
                                                componentsProps={{
                                                    typography: {
                                                        variant: "body2",
                                                    },
                                                }}
                                            />
                                        </FormGroup>
                                    </Stack>
                                    <Box gap={2} marginTop={1}>
                                        {checked && cart.length > 0
                                            ? cart.map((li, idx) => (
                                                  <ListSelectedBarang
                                                      key={String(li.id)}
                                                      pesan={li}
                                                      idx={idx}
                                                  />
                                              ))
                                            : ""}
                                    </Box>
                                </Box>

                                {/* Tombol Aksi */}
                                <Box sx={{ marginTop: "auto", paddingTop: 2 }}>
                                    <Stack
                                        direction={{ xs: "column-reverse", sm: "row" }}
                                        spacing={2}
                                        alignItems="center"
                                    >
                                        <Button
                                            data-testid="button-kembali"
                                            variant="outlined"
                                            onClick={() => {
                                                closeModalBayar();
                                                setChecked(false);
                                                setIsPasClicked(false);
                                                handleResetRincianPembayaran();
                                            }}
                                            fullWidth
                                        >
                                            <Typography>Kembali</Typography>
                                        </Button>

                                        <Button
                                            disabled={
                                                (totalTagihan > 0 && (inputBayar === 0 || inputBayar < totalTagihan)) ||
                                                (toggleDiskon === "persentase" && inputDiskon > 100 && totalTagihan > 0)
                                            }
                                            variant="contained"
                                            onClick={() => {
                                                if (diskonError) {
                                                    Swal.fire({
                                                        title: "Diskon tidak boleh melebihi total tagihan",
                                                        position: "top-end",
                                                        showConfirmButton: false,
                                                        icon: "error",
                                                        toast: true,
                                                        timer: 3000,
                                                        timerProgressBar: true,
                                                        showCloseButton: true,
                                                        customClass: {
                                                            container: "my-swal",
                                                        },
                                                    });
                                                    return;
                                                }

                                                const cartZeroFaktur =
                                                    cart.filter(
                                                        (li) =>
                                                            li.detailBundling
                                                                .length === 0 &&
                                                            li.faktur.length ===
                                                                0,
                                                    );

                                                let countBundling = 0;
                                                cart.forEach((li) =>
                                                    li.detailBundling.forEach(
                                                        (db) => {
                                                            if (db.newFaktur) {
                                                                return countBundling++;
                                                            }
                                                        },
                                                    ),
                                                );
                                                let count = 0;
                                                cart.forEach((li) =>
                                                    li.detailBundling.forEach(
                                                        () => {
                                                            return count++;
                                                        },
                                                    ),
                                                );

                                                const isNotEqual =
                                                    count !== countBundling;
                                                const notApproved =
                                                    checked &&
                                                    (cartZeroFaktur.length >
                                                        0 ||
                                                        isNotEqual);
                                                if (notApproved) {
                                                    Swal.fire({
                                                        title: "Pilih faktur terlebih dahulu",
                                                        position: "top-end",
                                                        showConfirmButton:
                                                            false,
                                                        icon: "error",
                                                        toast: true,
                                                        timer: 3000,
                                                        timerProgressBar: true,
                                                        showCloseButton: true,
                                                        customClass: {
                                                            container:
                                                                "my-swal",
                                                        },
                                                    });
                                                    return;
                                                }
                                                openModalKonfirmasiBayar();
                                                props.handlingRincianPembayaran(
                                                    toggleDiskon ===
                                                        "persentase"
                                                        ? inputDiskon
                                                        : 0,
                                                    displayDiskon,
                                                    ukmData
                                                        ? ukmData?.pajak
                                                        : 0,
                                                    displayPajak,
                                                    displayService,
                                                    ukmData
                                                        ? ukmData?.serviceCustom
                                                        : 0,
                                                    totalTagihan,
                                                    inputBayar,
                                                    kembalian,
                                                    sales,
                                                );
                                                setIsPasClicked(false);
                                            }}
                                            size="large"
                                            fullWidth
                                            data-testid="button-bayar"
                                        >
                                            <Typography>Bayar</Typography>
                                        </Button>
                                    </Stack>
                                </Box>
                            </Box>
                        </Grid>
                    </Stack>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

export default ModalBayar;